import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@fortem-monorepo/js-utilities';
import { Spinner } from '../Spinner';
export const LoadingScreen = ({ className, children }) => {
    return (_jsx("div", { className: cn('absolute top-1/2 left-1/2 -translate-1/2 w-full min-h-full p-10 flex items-center bg-white z-40', className), children: _jsxs("div", { className: 'flex flex-col items-center gap-2 mx-auto', children: [_jsx(Spinner, { className: 'size-12 stroke-primary' }), children] }) }));
};
